
		<div i18n="@@recoverPass-reset">
			<div class="dialog-title">Reset your password</div>
			<div class="dialog-message">The email has been sent successfully, use the pin we sent you in the mail to reset your password</div>
		</div>

		<form [formGroup]="form" (ngSubmit)="responsePin()">
			<fieldset class="fieldset">
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="pin">Pin</label>
						<input formControlName="pin" type="text" autocomplete="off">
						<validator [control]="form.controls['pin']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="newPassword" i18n="@@password">Password</label>
						<input formControlName="newPassword" type="password" autocomplete="off">
						<validator [control]="form.controls['newPassword']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="newPasswordConfirm" i18n="@@passwordConfirm">Password confirm</label>
						<input formControlName="newPasswordConfirm" type="password" autocomplete="off">
						<validator [control]="form.controls['newPasswordConfirm']"></validator>
					</div>
				</div>
			</fieldset>

			<div class="options">
				<button class="btn-text" type="submit" [disabled]="!form.valid">
					<span i18n="@@option-reset-pass">Reset password</span>
				</button>
			</div>
		</form>

		<a class="clickable-item link" routerLink="../" i18n="@@forgot-pass">Back to <u>Forgot password</u></a>
	